export default [
  {
    key: 'served_account_num',
    name: '有效账户数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'new_account_num',
    name: '新增账户数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'new_account_cost_num',
    name: '新增有消耗账户数',
    info: '筛选时间内创建且当日有消耗的账户数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'new_account_cost',
    name: '新增账户消耗',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'agent_num',
    name: '有效代理商数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'plan_num',
    name: '消费计划数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'unit_num',
    name: '消费单元数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'idea_num',
    name: '消费创意数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  },
  {
    key: 'gain',
    name: '涨幅数据',
    filterable: true,
    type: 'target',
    parent: 'account_statistics'
  }
];
